
export class SocorrosContacto {
    nombre: string;
    institucion: any;
    cargo: string;
    telefono1: string;
    telefono2: string;
    id_contacto: number;
}